import React from 'react'

export const TextArea = ({ classname = "", value, onChange, onBlur,placeholder=""}) => {
    return (
        <textarea className={classname} value={value} onChange={onChange} onBlur={onBlur} placeholder={placeholder} >
           
        </textarea>
    )
}
